import { Injectable } from '@angular/core';
import { sha256 } from 'js-sha256';


@Injectable({
  providedIn: 'root'
})
export class CryptPasswordService {

  constructor() { }

  cryptPassword(password: string): string {
    const hash = sha256.create();
    hash.update(password);
    hash.hex();
    const passwordConvert = btoa(hash.toString());
    return passwordConvert;
  }
}
